import { getMainIconViewBox } from '../sidenav.style';

export const getLogoViewBox = screenSize => getMainIconViewBox(screenSize);

export * from '../../tornado/brand-icon/customer/default/brandIcon.utils';
